import { cn } from '@/lib/utils';
import { DataTableLoading } from './DataTableLoading';

const DEFAULT_ROW_COUNT = 5;

interface TableSkeletonProps {
  columnCount: number;
  rowCount?: number;
  className?: string;
}

export function TableSkeleton({
  columnCount,
  rowCount = DEFAULT_ROW_COUNT,
  className,
}: TableSkeletonProps) {
  return (
    <div className={cn('overflow-hidden rounded-lg border', className)} aria-busy="true">
      <table className="w-full text-sm">
        <tbody>
          <DataTableLoading columnCount={columnCount} rowCount={rowCount} />
        </tbody>
      </table>
    </div>
  );
}
